import type { SessionService } from '../services/session.service';
import {
  PRACTICE_TABS,
  type PracticeTab,
} from '../../pages/settings/practice-tab-config';

export interface PracticeTabFeatureFlags {
  referenceReportAnalyzer?: boolean;
}

export function canAccessPracticeTab(
  tab: PracticeTab,
  sessionService: SessionService,
  featureFlags?: PracticeTabFeatureFlags
): boolean {
  if (tab.route === 'reference-reports' && featureFlags?.referenceReportAnalyzer !== true) {
    return false;
  }
  const isAdminOrPracticeAdmin =
    sessionService.isAdmin() || sessionService.isPracticeAdmin();
  if (tab.adminOrPracticeAdminOnly && !isAdminOrPracticeAdmin) {
    return false;
  }
  if (tab.permission == null) {
    return true;
  }
  return sessionService.hasPracticeTabAccess(tab.permission)();
}

export function findPracticeTabByRoute(route: string): PracticeTab | undefined {
  return PRACTICE_TABS.find((tab) => tab.route === route);
}

export function findFirstAccessiblePracticeTab(
  sessionService: SessionService,
  featureFlags?: PracticeTabFeatureFlags
): PracticeTab | undefined {
  return PRACTICE_TABS.find((tab) =>
    canAccessPracticeTab(tab, sessionService, featureFlags)
  );
}

export function getVisiblePracticeTabs(
  sessionService: SessionService,
  featureFlags?: PracticeTabFeatureFlags
): PracticeTab[] {
  return PRACTICE_TABS.filter((tab) =>
    canAccessPracticeTab(tab, sessionService, featureFlags)
  );
}
